import { CustomAlertDialogId } from 'src/types/Id';

export const KEY_NAME = 'customAlertDialogId';

export function setLastActiveCustomAlertDialogIdInLocalStorage(value: CustomAlertDialogId): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value));
}
